import React from "react";
import '../css/about.css';


import artistData from "./placeholder/artistData";

import ArtistCard from './../layout/artist_card';


function About() {


    return (

        <section id='About'>

            <div className="container about__container">

                <h1>Artist</h1>
                
                <div className="artist">
                    {artistData.map ( (data) => {

                        return <ArtistCard  
                                    artistName={data.name}
                                    artistImg={data.img}
                                    artistDes={data.info}
                                    />

                    })}

                </div>

                
                
            </div>

        </section>

    );

}

export default About;